export const USER_SETTINGS_NOTIFICATIONS = {
  sent: {
    id: 'sent',
    label: 'label.EMAIL_SENT',
    description: 'Receive email notification when email is sent.',
    items: {
      desktopnotifymsg: {
        id: 'desktopnotifybeaconview',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: 'Receive email notification when email is opened.'
      }
    }
  },
  view: {
    id: 'view',
    label: 'label.EMAIL_VIEWS',
    description: 'Receive email notification when tracked attachment viewer is launched.',
    items: {
      desktopnotifybeaconview: {
        id: 'desktopnotifybeaconview',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: 'Receive email notification when email is opened.'
      },
      pushnotifybeaconview: {
        id: 'pushnotifybeaconview',
        label: 'label.ENABLE_PUSH_NOTIFICATIONS',
        description: 'Receive email notification when email is opened.'
      },
      notifybeaconview: {
        id: 'notifybeaconview',
        label: 'label.ENABLE_EMAIL_NOTIFICATIONS',
        description: 'Receive email notification when email is opened.'
      }
    }
  },
  attachmentview: {
    id: 'attachmentsview',
    label: 'label.ATTACHMENT_VIEWS',
    description: 'Receive email notification when tracked attachment viewer is launched.',
    items: {
      desktopnotifyattachmentview: {
        id: 'desktopnotifyattachmentview',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: 'Receive email notification when tracked attachment viewer is launched.'
      },
      pushnotifyattachmentview: {
        id: 'pushnotifyattachmentview',
        label: 'label.ENABLE_PUSH_NOTIFICATIONS',
        description: 'Receive email notification when tracked attachment viewer is launched.'
      },
      notifyattachmentview: {
        id: 'notifyattachmentview',
        label: 'label.ENABLE_EMAIL_NOTIFICATIONS',
        description: 'Receive email notification when tracked attachment viewer is launched.'
      }
    }
  },
  attachmentdownload: {
    id: 'attachmentsdownload',
    label: 'label.ATTACHMENT_DOWNLOADS',
    description: 'Receive email notification when tracked attachment is downloaded.',
    items: {
      desktopnotifyattachmentdownload: {
        id: 'desktopnotifyattachmentdownload',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: 'Receive email notification when tracked attachment is downloaded.'
      },
      pushnotifyattachmentdownload: {
        id: 'pushnotifyattachmentdownload',
        label: 'label.ENABLE_PUSH_NOTIFICATIONS',
        description: 'Receive email notification when tracked attachment is downloaded.'
      },
      notifyattachmentdownload: {
        id: 'notifyattachmentdownload',
        label: 'label.ENABLE_EMAIL_NOTIFICATIONS',
        description: 'Receive email notification when tracked attachment is downloaded.'
      }
    }
  },
  ad: {
    id: 'ad',
    label: 'label.AD_CLICKS',
    description: 'Receive email notification when banner or text advertisement is clicked.',
    items: {
      desktopnotifyadclick: {
        id: 'desktopnotifyadclick',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: 'Receive email notification when banner or text advertisement is clicked.'
      },
      pushnotifyadclick: {
        id: 'pushnotifyadclick',
        label: 'label.ENABLE_PUSH_NOTIFICATIONS',
        description: 'Receive email notification when banner or text advertisement is clicked.'
      },
      notifyadclick: {
        id: 'notifyadclick',
        label: 'label.ENABLE_EMAIL_NOTIFICATIONS',
        description: 'Receive email notification when banner or text advertisement is clicked.'
      }
    }
  },
  video: {
    id: 'video',
    label: 'label.VIDEO_VIEWS',
    description: 'Receive email notification when your video is viewed.',
    items: {
      desktopnotifymyvideoactivity: {
        id: 'desktopnotifymyvideoactivity',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: 'Receive email notification when your video is viewed.'
      },
      pushnotifymyvideoactivity: {
        id: 'pushnotifymyvideoactivity',
        label: 'label.ENABLE_PUSH_NOTIFICATIONS',
        description: 'Receive email notification when your video is viewed.'
      },
      notifymyvideoactivity: {
        id: 'notifymyvideoactivity',
        label: 'label.ENABLE_EMAIL_NOTIFICATIONS',
        description: 'Receive email notification when your video is viewed.'
      }
    }
  },
  link: {
    id: 'link',
    label: 'label.LINK_CLICKS',
    description: 'Receive email notification when tracked link is clicked.',
    items: {
      desktopnotifylinkclick: {
        id: 'desktopnotifylinkclick',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: 'Receive email notification when tracked link is clicked.'
      },
      pushnotifylinkclick: {
        id: 'pushnotifylinkclick',
        label: 'label.ENABLE_PUSH_NOTIFICATIONS',
        description: 'Receive email notification when tracked link is clicked.'
      },
      notifylinkclick: {
        id: 'notifylinkclick',
        label: 'label.ENABLE_EMAIL_NOTIFICATIONS',
        description: 'Receive email notification when tracked link is clicked.'
      }
    }
  },
  website: {
    id: 'website',
    label: 'label.WEBSITE_VISITS',
    description: 'Receive email notification when tracked link is clicked.',
    items: {
      desktopnotifywebsitevisit: {
        id: 'desktopnotifywebsitevisit',
        label: 'label.ENABLE_DESKTOP_NOTIFICATIONS',
        description: ''
      },
      pushnotifywebsitevisit: {
        id: 'pushnotifywebsitevisit',
        label: 'label.ENABLE_PUSH_NOTIFICATIONS',
        description: ''
      },
      notifywebsitevisit: {
        id: 'notifywebsitevisit',
        label: 'label.ENABLE_EMAIL_NOTIFICATIONS',
        description: ''
      }
    }
  }
};
